import { UPDATE_USER_PROFILE_INFO } from './actionTypes';

export const updateUserProfileInfo = (payload) => {
    return {
        type: UPDATE_USER_PROFILE_INFO,
        payload,
    }
}

